import {
  Grid,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import CnjTableRow from "./cnj-table-row";

const entes = ["Municipal", "Estadual", "Federal"];

const createData = (name, total, municipal, estadual, federal, enteData) => {
  return { name, total, enteData, history: [{ municipal, estadual, federal }] };
};

const CnjTable = ({ data, state, totalCnj }) => {
  const [showAll, setShowAll] = useState(false);
  const [rows, setRows] = useState([]);

  const toggleAll = () => setShowAll(!showAll);

  useEffect(() => {
    if (showAll) {
      let arr = [];
      let total = 0;

      Object.keys(data).map((tribunal) => {
        const tribunalHash = data[tribunal];
        const enteData = {};

        let municipal = 0;
        let estadual = 0;
        let federal = 0;

        entes.map((ente) => {
          const data = tribunalHash[ente];

          enteData[ente] = data;

          if (data != undefined || data != null) {
            const val = data.valores;
            total += val;

            switch (ente) {
              case "Municipal":
                municipal = val;
                break;
              case "Estadual":
                estadual = val;
                break;
              case "Federal":
                federal = val;
                break;
              default:
                break;
            }
          }
        });

        if (tribunal != "TJMMG") {
          arr.push(
            createData(tribunal, total, municipal, estadual, federal, enteData)
          );
        }
      });

      setRows(arr);
    } else {
      setRows([]);
    }
  }, [showAll]);

  useEffect(() => {
    let arr = [];
    let total = 0;

    state.tribunais.map((tribunal, i) => {
      const tribunalHash = data[tribunal];
      const enteData = {};

      let municipal = 0;
      let estadual = 0;
      let federal = 0;

      entes.map((ente) => {
        const data = tribunalHash[ente];

        enteData[ente] = data;

        if (data != undefined || data != null) {
          const val = data.valores;
          total += val;

          switch (ente) {
            case "Municipal":
              municipal = val;
              break;
            case "Estadual":
              estadual = val;
              break;
            case "Federal":
              federal = val;
              break;
            default:
              break;
          }
        }
      });

      arr.push(
        createData(tribunal, total, municipal, estadual, federal, enteData)
      );
    });

    setRows(arr);
  }, [state]);

  function Row(props) {
    const { row } = props;
    const classes = useRowStyles();
    const [open, setOpen] = useState(false);

    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>

          <TableCell component="th" scope="row" align="center">
            {row.name}
          </TableCell>

          <TableCell align="center">
            {new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(row.total / 100)}
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Table
                  size="small"
                  aria-label="purchases"
                  style={{ marginBottom: "15px" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell>Municipal</TableCell>
                      <TableCell>Estadual</TableCell>
                      <TableCell>Federal</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {row.history.map((historyRow, i) => {
                      return (
                        <React.Fragment key={i}>
                          <TableRow>
                            <TableCell>Valor total</TableCell>

                            <TableCell component="th" scope="row">
                              {new Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              }).format(historyRow.municipal / 100)}
                            </TableCell>

                            <TableCell component="th" scope="row">
                              {new Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              }).format(historyRow.estadual / 100)}
                            </TableCell>

                            <TableCell>
                              {new Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              }).format(historyRow.federal / 100)}
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>
                              % em relação ao total da seleção
                            </TableCell>

                            <TableCell>
                              {RuleOfThree(historyRow.municipal, row.total)}
                            </TableCell>

                            <TableCell>
                              {RuleOfThree(historyRow.estadual, row.total)}
                            </TableCell>

                            <TableCell>
                              {RuleOfThree(historyRow.federal, row.total)}
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>% em relação ao total do CNJ</TableCell>

                            <TableCell>
                              {RuleOfThree(historyRow.municipal, totalCnj)}
                            </TableCell>

                            <TableCell>
                              {RuleOfThree(historyRow.estadual, totalCnj)}
                            </TableCell>

                            <TableCell>
                              {RuleOfThree(historyRow.federal, row.total)}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  Row.propTypes = {
    row: PropTypes.shape({
      total: PropTypes.number.isRequired,
      history: PropTypes.arrayOf(
        PropTypes.shape({
          municipal: PropTypes.number.isRequired,
          estadual: PropTypes.number.isRequired,
          federal: PropTypes.number.isRequired,
        })
      ).isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  };

  return (
    <Grid item sm={12} md={8}>
      <Paper style={{ marginBottom: "25px" }}>
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell vertical-align="center" style={{ width: "30%" }}>
                  <Switch
                    checked={showAll}
                    onChange={toggleAll}
                    disabled={state.tribunais.length > 0}
                  />
                  Mostrar todos tribunais
                </TableCell>

                <TableCell align="center">Tribunal</TableCell>
                <TableCell align="center">Valor Total</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row) => (
                <CnjTableRow key={row.name} row={row} totalValue={totalCnj} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
};

export default CnjTable;
